import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["list", "item"]
  static values = { url: String }

  connect() {
    this.draggedElement = null
    this.dragOverElement = null
  }

  dragStart(event) {
    if (event.target.tagName === 'BUTTON' || event.target.closest('button')) {
      event.preventDefault()
      return false
    }

    this.draggedElement = event.currentTarget
    event.currentTarget.classList.add('opacity-50', 'cursor-grabbing')
    event.dataTransfer.effectAllowed = 'move'
  }

  dragEnd(event) {
    event.currentTarget.classList.remove('opacity-50', 'cursor-grabbing')
    this.itemTargets.forEach(item => {
      item.classList.remove('border-indigo-500', 'ring-2', 'ring-indigo-500')
    })
    this.draggedElement = null
    this.dragOverElement = null
  }

  dragOver(event) {
    event.preventDefault()
    event.dataTransfer.dropEffect = 'move'

    const item = event.currentTarget
    if (item === this.draggedElement || item === this.dragOverElement) return

    if (this.dragOverElement) {
      this.dragOverElement.classList.remove('border-indigo-500', 'ring-2', 'ring-indigo-500')
    }

    item.classList.add('border-indigo-500', 'ring-2', 'ring-indigo-500')
    this.dragOverElement = item
  }

  dragLeave(event) {
    if (!event.currentTarget.contains(event.relatedTarget)) {
      event.currentTarget.classList.remove('border-indigo-500', 'ring-2', 'ring-indigo-500')
      this.dragOverElement = null
    }
  }

  drop(event) {
    event.preventDefault()
    if (!this.draggedElement || this.draggedElement === event.currentTarget) return

    const dropTarget = event.currentTarget
    const children = Array.from(this.listTarget.children)
    const draggedIndex = children.indexOf(this.draggedElement)
    const dropIndex = children.indexOf(dropTarget)

    if (draggedIndex < dropIndex) {
      this.listTarget.insertBefore(this.draggedElement, dropTarget.nextSibling)
    } else {
      this.listTarget.insertBefore(this.draggedElement, dropTarget)
    }

    dropTarget.classList.remove('border-indigo-500', 'ring-2', 'ring-indigo-500')
    this.draggedElement = null
    this.dragOverElement = null

    this.saveOrder()
  }

  saveOrder() {
    const ids = this.itemTargets.map(item => item.dataset.highlightId)
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    fetch(this.urlValue, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken
      },
      body: JSON.stringify({ highlight_ids: ids })
    })
  }
}
